import React, { useContext, Fragment } from 'react'

import { EngravingContext } from 'components/buy/Engraving/EngravingContext'
import { ProductContainer, ProductName, ProductFigureWrap, ProductFigure } from 'components/buy/Addon'
import { EngravingActions } from 'components/buy/Engraving/EngravingComponents'

const EngravingAddon = () => {
  const { engraving, skipItem, proceedItem, setVisible } = useContext(EngravingContext)

  return (
    <>
      {Object.keys(engraving).map(i => {
        const item = engraving[i]

        if (typeof item === 'object') {
          return (
            <Fragment key={i}>
              {Object.keys(item).map(k => {
                const key = item[k]

                if (typeof key === 'object' && key.value.length > 0) {
                  if (k === 'text') {
                    return (
                      <ProductContainer key={`${i}-${k}`}>
                        <ProductName>
                          {`${i} ${k}: `}
                          {key.value}
                        </ProductName>
                        <EngravingActions
                          onRemove={() => {
                            skipItem(i)
                          }}
                          onEdit={() => {
                            setVisible(true)
                            proceedItem(i, null, false)
                          }}
                        />
                      </ProductContainer>
                    )
                  } else if (k === 'miniIcon') {
                    return (
                      <ProductContainer key={`${i}-${k}`}>
                        <ProductName>
                          {`${i} ${k}: `}
                          {key.name}
                        </ProductName>
                        <ProductFigureWrap>
                          <ProductFigure
                            src={`${
                              process.env.BASE_PATH
                            }/images/engraving/icons/thumbnails/${key.name.toLowerCase()}.svg`}
                            alt={`${i} ${k}`}
                          />
                        </ProductFigureWrap>
                        <EngravingActions
                          onRemove={() => {
                            skipItem(i)
                          }}
                          onEdit={() => {
                            setVisible(true)
                            proceedItem(i, null, false)
                          }}
                        />
                      </ProductContainer>
                    )
                  } else {
                    return (
                      <ProductContainer key={`${i}-${k}`}>
                        <ProductName>
                          {`${i} ${k}: `}
                          {key.name}
                        </ProductName>
                        <ProductFigureWrap>
                          <ProductFigure src={key.value} alt={`${i} ${k}:`} />
                        </ProductFigureWrap>
                        <EngravingActions
                          onRemove={() => {
                            skipItem(i)
                          }}
                          onEdit={() => {
                            setVisible(true)
                            proceedItem(i, null, false)
                          }}
                        />
                      </ProductContainer>
                    )
                  }
                }
              })}
            </Fragment>
          )
        }
      })}
    </>
  )
}

export default EngravingAddon
